export enum PopUpId {
    EMERPOP = 'emer',
    OTHERVEHPOP = 'otherveh',
    SECCONTACTPOP = 'seccont',
    PREFERPOP = 'pref',
    SVTSTATUSPOP = 'svtstatus',
    SECURITYALARAMPOP = 'secalarm',
    TRIPSCOREPOP = 'tripScore',
    DASHBOARDPOP = 'dashboard',
    SERVICEHISTPOP = 'servhistory',
    RSAPOP = 'rsa',
    TRANSACTIONPOP = 'trans',
    CALLBACKPOP = 'callBack',
    ERRMSGPOP = 'errMsg',
    NEARBYERROR = 'Invalid VIN. Location not found',
    ERROR = 'Something went wrong, try again',
    MCALLCOUNT = 'mcallcount',
    CTICALLBACK = 'ctiCallBack',
    FUELLOG = 'fuelLog',
    INSURANCEPOP = 'insurance'
}
